import React, {useEffect} from 'react';
import {useSidebar} from '@src/components/shadcn/sidebar';
import {Link} from 'react-router-dom';
import EzManageLogoRebrand from '@src/components/EzManageLogoRebrand';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faXmarkLarge} from '@fortawesome/pro-light-svg-icons';
import cn from '@src/util/cnHelper';
import {NavItem} from './types';

const NavHeader = ({homeNavItem}: {homeNavItem: NavItem}) => {
  const {isMobile, openMobile, setOpenMobile} = useSidebar();

  useEffect(() => {
    if (isMobile) {
      setOpenMobile(false);
    }
  }, [isMobile, setOpenMobile]);

  const toggleMobileNavbar = () => {
    setOpenMobile(!openMobile);
  };
  return (
    <div
      className={cn(
        'flex justify-between inset-0 w-full md:w-[--sidebar-width]',
        'pt-5 pb-2 px-6 items-start border-r border-peppercorn-200'
      )}
    >
      {homeNavItem.isLinkToActiveApp ? (
        <Link className="block" to={homeNavItem.to}>
          <EzManageLogoRebrand />
        </Link>
      ) : (
        <a className="block" href={homeNavItem.to}>
          <EzManageLogoRebrand />
        </a>
      )}
      {isMobile && (
        <FontAwesomeIcon
          onClick={toggleMobileNavbar}
          className="cursor-pointer"
          icon={openMobile ? faXmarkLarge : faBars}
        />
      )}
    </div>
  );
};

export default NavHeader;
